<template>
  <div id="app">
    <router-view class="children_view" :class="{'scroll_view': scrollView}" ref="children_view"></router-view>
    <modal></modal>
    <toast></toast>
    <loading></loading>
  </div>
</template>
<script>
import modal from "./components/modal";
import toast from "./components/toast";
import loading from "./components/loading";
export default {
  name: "App",
  data() {
    return {
      scrollRouteArr: [
        'demo',
        'nationalDetail'
      ],
      transitionName: "",
      scrollView: false
    };
  },
  beforeMount () {
    let u = navigator.userAgent;
    this.scrollView = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios
  },
  mounted(e) {
    document.getElementById("app").addEventListener("scroll", this.toggleHead);
  },
  watch: {
    // 监听路由变化，关闭组件
    $route (to, from) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.hideModal();
      this.$store.commit("beDefault", {});
    }
  },
  methods: {
    toggleHead(e) {
      if (this.scrollRouteArr.indexOf(this.$route.name) === -1) return false;
      let scrollBottom = document.getElementsByClassName("children_view")[0].clientHeight - document.getElementById("app").scrollTop - window.innerHeight;
      if (scrollBottom <= 100) this.$store.commit('setwithBottom', scrollBottom);
    }
  },
  components: {
    modal,
    toast,
    loading
  }
};
</script>

<style lang="scss">
@import "./assets/css/reset.scss";
@import "./assets/css/public.scss";
#app {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  // position: relative;
  background: #f5f5f5;
  // -webkit-overflow-scrolling: touch;
  .children_view {
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    transition: all 350ms;
    &.scroll_view{
      min-height:calc(100% + 1px);
    }
  }
  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active {
    will-change: transform;
    transition: all 350ms;
    position: absolute;
  }
  .slide-right-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  .slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  .slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  .slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .van-picker__toolbar{
    line-height:88px;
    height:88px;
    button {
      font-size:30px;
    }
  }
  .van-picker-column{
    font-size:30px !important;
  }
  .public_no_data {
    text-align: center;
    color: #999;
    font-size: 28px;
    padding-top: 450px;
    background: url('../src/assets/img/icon_no_data.png') no-repeat center 150px / 273px 273px;
  }
  .public_no_more {
    text-align: center;
    color: #999;
    font-size: 24px;
    padding: 10px 0;
  }

  .download_wrap{
    height:120px;
    width:100%;
    padding:0 30px;
    position:fixed;
    left:0;
    bottom:0;
    z-index:10;
    display:flex;
    align-items: center;
    justify-content: space-between;
    background:rgba($color: #000000, $alpha: 0.6);
    color:#fff;
    .left_wrap{
      display:flex;
      align-items: center;
      .logo{
        width:100px;
        height:100px;
        border-radius: 16px;
        margin-right:30px;
      }
      .name{
        font-size:32px;
        font-weight: bold;
      }
    }
    .btn{
      width:170px;
      height:72px;
      background:rgba(178,7,0,1);
      border-radius: 16px;
      line-height:72px;
      text-align:center;
      font-size:28px;
    }
  }
}
</style>
